<template>
  <div class="uploaddemo">
    <!-- <el-popover placement="bottom" width="200" trigger="click" v-model="visible">
      :action="'/index/Export_Excel/ImportFile?'+'jparams='+JSON.stringify(jparam)"
      
      action="/index/Export_Excel/ImportFile"
    -->
    <el-upload
      style="border:none;padding:0"
      :action="'http://118.190.210.223:8090/index/Export_Excel/ImportFile?'+'jparams='+JSON.stringify(jparam)"
      :on-success="handleAvatarSuccess"
      :disabled="!$attrs.uploaddemo.typeCode"
      :before-upload="beforeAvatarUpload"
      :data="jparam"
      accept="xls/xlsx"
      :show-file-list="false"
    >
      <el-button
        size="small"
        class="download"
        @click="jparamsd"
        :disabled="!$attrs.uploaddemo.typeCode"
      >
        <i class="el-icon-download"></i>导入
      </el-button>
    </el-upload>
    <div v-if="dialogVisible" class="uploaddemo_box">
      <div class="uploaddemo_box_img">
        <img src="@/assets/Images/jz.gif" alt />
        <div class="uploaddemo_box_text">数据导入中</div>
      </div>
    </div>
  </div>
</template>

<script>
import tool from "@/utils/tool.js";
let numbername = "";

export default {
  name: "popover",
  data() {
    return {
      dialogVisible: false,
      visible: false,
      jparam: {
        user_id: tool.getLocal("userid"), //用户id
        session_id: tool.getLocal("sessionid"), //用户凭证
        Model: this.$attrs.uploaddemo.Model, // 导入Excel的模块名称
        ParentNo: this.$attrs.dataslist, //
        KtypeId: this.$attrs.uploaddemo.KtypeId //仓库ID，导入库存期初使用
      },
      jparams: {
        user_id: tool.getLocal("userid"), //用户id
        session_id: tool.getLocal("sessionid"), //用户凭证
        type: "other",
        numbers: numbername //tool.getLocal("paramsl_numbers")
      },
      fileList: []
      // files: ""
    };
  },
  methods: {
    jparamsd() {
      this.jparam.KtypeId = this.$attrs.uploaddemo.KtypeId;
      this.jparam.ParentNo = this.$attrs.dataslist;
    },
    beforeAvatarUpload(file) {
      this.dialogVisible = true;
      let arr = file.name.split(".");
      const isxls = arr[arr.length - 1] === "xls" || arr[1] === "xlsx";
      // const isPNG = file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 10;
      // if (!isJPG && !isPNG) {
      if (!isxls) {
        this.$message.error("上传文件只能是 xls/xlsx 格式!");
        return false;
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 10MB!");
        return false;
      }
      return isxls && isLt2M;
    },
    // 文件上传成功时的钩子
    handleAvatarSuccess(res, file) {
      if (res.status == 0) {
        this.$emit("handleAvatarSuccess", res);
        this.$message({
          showClose: true,
          message: res.description,
          type: "success"
        });
      } else if (res.status == 70002) {
        this.$message({
          message: res.description,
          type: "warning"
        });
      } else if (res.status == 1) {
        this.$message({
          message: "必须录入仓库",
          type: "warning"
        });
      } else {
        this.$message({
          message: res.description,
          type: "warning"
        });
      }
      this.dialogVisible = false;
    }
  },
  created() {},
  watch: {
    // jparam: {
    //   handler(newValue, oldValue) {
    //   }
    // }
  }
};
</script>
<style lang="less" scoped>
#uploaddemo {
  .reference {
    span {
      font-size: 14px !important;
    }
    .download {
      padding: 7px 16px;
    }
  }
  .el-dialog__headerbtn .el-dialog__close {
    display: none !important;
  }
}
.uploaddemo_box {
  position: fixed;
  top: 0;
  z-index: 4005;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  .uploaddemo_box_img {
    position: relative;
    top: 35%;
    right: -41%;
    z-index: 4006;
    // text-align: center;
  }
  .uploaddemo_box_text {
    position: relative;
    top: -90px;
    right: -114px;
    z-index: 4006;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Common/ImportPopover/ImportPopover.vue